module.exports = __webpack_public_path__ + "img/chrome3.07f36e64.png";